import {API,Auth} from 'aws-amplify'
import store from '../redux/store';
export default class Portal{
    readAccount(){
        return new Promise((resolve,reject) =>{
            Auth.currentSession().then(response =>{
                const init = {
                    headers: {'Content-type': 'application/json','Authorization':response.getIdToken().getJwtToken()},
                }
    
                API.get('PatientAuth','/portal?type=account',init).then(readResponse =>{
                    resolve(readResponse);
                }); 
            })
        })
    }

    readExams(){
        return new Promise((resolve,reject)=>{
            Auth.currentSession().then(response =>{
                const init = {
                    headers: {'Content-type': 'application/json','Authorization':response.getIdToken().getJwtToken()},
                }
    
                API.get('PatientAuth','/portal?type=exams',init).then(readResponse =>{
                    resolve(readResponse);
                }); 
            })
        })
    }

    readForms(){
        return new Promise((resolve,reject)=>{
            Auth.currentSession().then(response =>{
                const init = {
                    headers: {'Content-type': 'application/json','Authorization':response.getIdToken().getJwtToken()},
                }
    
                API.get('PatientAuth','/portal?type=forms',init).then(readResponse =>{
                    resolve(readResponse);
                }); 
            })
        })
    }

    selfCheckup(){
        return new Promise((resolve,reject)=>{
            Auth.currentSession().then(response =>{
                const init = {
                    headers: {'Content-type': 'application/json','Authorization':response.getIdToken().getJwtToken()},
                }
    
                API.get('PatientAuth','/portal?type=selfCheckup&name=' + store.getState().user.name,init).then(readResponse =>{
                    resolve(readResponse);
                }); 
            })
        })
    }    
}